<template>
  <div class="page-content creditAnalyze">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>违规处理</el-breadcrumb-item>
      <el-breadcrumb-item>违规信息分析</el-breadcrumb-item>
    </el-breadcrumb>
    <section>
      <div>
        <el-tag type="warning" style="width: 100%;">
          <img src="../../../assets/img/other/trumpet_icon.png" style="margin-left: 13px;margin-right: 5px;">
          <span>
            违规信息分析的数据，仅包含处理完结的违规数据，正在处理过程中的数据不参与统计分析，时间依据处理时间统计。
          </span>
        </el-tag>
      </div>
      <!-- <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        <span class="promptFont">
          违规信息分析的数据，仅包含处理完结的违规数据，正在处理过程中的数据不参与统计分析，时间依据处理时间统计。
        </span>
      </div> -->
      <div>
        <div class="flex-between margin_top_bottom20 flex-vereical-center">
          <div class="drawer-subtitle_common no_margin">
            <span>违规信息处理概览</span>
          </div>
          <div class='fix_top'>
            <span
              v-for="(item,index) in historyDate"
              :key="index"
              :class="index===historyIndex?'active':''"
              class="data_right"
              @click="changeHistory(index)"
            >{{item.name}}</span>
            <el-date-picker
              v-model="timeDate"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              size="small"
              @change="changeHistory"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <el-card :body-style="{ padding: '20px',position:'relative' }" shadow="nerver">
        <div class="flex-between flex-average">
          <div
            class="tab_relative"
            v-for="(item,index) in countShow"
            :key="index"
            :class="index==countShow.length-1?'':'border-left-shadow'"
          >
            <div>
              <div>{{item.name}}</div>
              <div>
                <span class="f30">{{item.number}}</span>
                <span v-if="item.totle != 0">  占总量  {{item.totle}}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <div class="drawer-subtitle_common">
        <span>违规链接来源及数量分析</span>
      </div>
      <el-card
        class="out-review-card card_relative"
        :body-style="{ padding: '20px' }"
        shadow="nerver"
      >
        <img
          :src="require('@/assets/img/other/table-show-icon.png')"
          class="table-show-iocn"
          @click="tableSHow(1)"
        />
        <div id="outCharts" :style="{width: '100%', height: '340px'}"></div>
      </el-card>
      <el-row>
        <el-col :span="12">
          <div style="width:100%">
            <div class="drawer-subtitle_common">
              <span>违规链接所属平台占比</span>
            </div>
            <el-card class="card_relative">
              <img
                :src="require('@/assets/img/other/table-show-icon.png')"
                class="table-show-iocn"
                @click="tableSHow(2)"
              />
              <div id="platformCharts" :style="{width: '100%', height: '340px'}"></div>
            </el-card>
          </div>
        </el-col>

        <el-col :span="12">
          <div style="width:100%;margin-left: 20px;">
            <div class="drawer-subtitle_common flex_between">
              <span>违规产品排名</span>
              <div>
                <img
                  :src="require('@/assets/img/other/down_chart.png')"
                  style="margin-right:10px;"
                  class="down_chart"
                  @click="readyDownload(6)"
                />
                <img
                  :src="require('@/assets/img/other/table-show-icon.png')"
                  style="margin-right:20px;"
                  @click="tableSHow(6)"
                />
              </div>
            </div>
            <div style="background-color: white;padding: 20px;border-radius: 15px;height: 340px;margin-right: 20px;">
              <el-table
                :data="listData.groupCountByProduct"
                header-row-class-name="data-table-header-style"
                v-loading="shopLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-text="拼命加载中"
                height="320"
              >
                <el-table-column label="排名" min-width="15%">
                  <template slot-scope="scope">
                    <div :class="scope.$index<=2?'right_num':'unright_num'">{{scope.$index+1}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品" prop="productname" min-width="70%">
                </el-table-column>
                <el-table-column label="链接数" prop="count" min-width="15%">
                </el-table-column>
              </el-table>
            </div>

          </div>
        </el-col>

        <el-col :span="15">
          <div style="width:100%;">
            <div class="drawer-subtitle_common flex_between">
              <span>授权店铺违规情况排名</span>
              <div>
                <img
                  :src="require('@/assets/img/other/down_chart.png')"
                  style="margin-right:10px;"
                  class="down_chart"
                  @click="readyDownload(3)"
                />
                <img
                  :src="require('@/assets/img/other/table-show-icon.png')"
                  style="margin-right:10px;"
                  @click="tableSHow(3)"
                />
              </div>
            </div>
            <div style="background-color: white;padding: 20px;border-radius: 15px;height: 340px;">
              <el-table
                :data="listData.groupByShopname"
                header-row-class-name="data-table-header-style"
                v-loading="shopLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-text="拼命加载中"
                style="width: 100%;background-color: white;padding: 20px;border-radius: 15px;"
                height="320"
              >
                <el-table-column label="排名" min-width="10%">
                  <template slot-scope="scope">
                    <div :class="scope.$index<=2?'right_num':'unright_num'">{{scope.$index+1}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="平台" min-width="15%" prop="platform">
                </el-table-column>
                <el-table-column label="店铺" min-width="30%" prop="shopname">
                </el-table-column>
                <el-table-column label="违规总次数" min-width="15%" prop="count" sortable>
                </el-table-column>
                <el-table-column label="整改合格" min-width="15%" prop="passNum" sortable>
                </el-table-column>
                <el-table-column label="申诉合理" min-width="15%" prop="appealNum" sortable>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>

        <el-col :span="9">
          <div style="width:100%;margin-left: 20px;">
            <div class="drawer-subtitle_common flex_between">
              <span>举报人举报次数排行</span>
              <div>
                <img
                  :src="require('@/assets/img/other/down_chart.png')"
                  style="margin-right:10px;"
                  class="down_chart"
                  @click="readyDownload(7)"
                />
                <img
                  :src="require('@/assets/img/other/table-show-icon.png')"
                  style="margin-right:20px;"
                  @click="tableSHow(7)"
                />
              </div>
            </div>
            <div style="background-color: white;padding: 20px;border-radius: 15px;height: 340px;margin-right: 20px;">
              <el-table
                :data="listData.groupCountByCreateusername"
                header-row-class-name="data-table-header-style"
                v-loading="shopLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-text="拼命加载中"
                height="320"
              >
                <el-table-column label="排名" min-width="10%">
                  <template slot-scope="scope">
                    <div :class="scope.$index<=2?'right_num':'unright_num'">{{scope.$index+1}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="举报人" prop="createusername" min-width="70%">
                </el-table-column>
                <el-table-column label="举报链接数" prop="count" min-width="20%">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="flex-between">
        <div style="width:65%">
          <div class="drawer-subtitle_common">
            <span>授权店铺链接违规处理结果分析</span>
          </div>
          <el-card style="height:475px" class="card_relative">
            <img
              :src="require('@/assets/img/other/table-show-icon.png')"
              class="table-show-iocn"
              @click="tableSHow(4)"
            />
            <div id="platformCharts2" :style="{width: '100%', height: '430px'}"></div>
          </el-card>
        </div>
        <div style="width:34.5%">
          <div class="drawer-subtitle_common flex_between">
            <span>非授权链接处理方式分析</span>

          </div>
          <el-card style="height: 475px;margin-left: 14px;">
            <div ref="noAuth" id="noAuth">
              <div class='right'>
                <img
                  :src="require('@/assets/img/other/down_chart.png')"
                  style="margin-right:10px;"
                  class="down_chart"
                  @click="generatorImage('noAuth','非授权链接处理方式分析')"
                />
                <img
                  :src="require('@/assets/img/other/table-show-icon.png')"
                  style="margin-right:10px;"
                  @click="tableSHow(5)"
                />
              </div>
              <div id="platformCharts4" :style="{width: '100%', height: '400px'}"></div>
            </div>
          </el-card>
        </div>
      </div>
    </section>
    <!-- //表格 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="840px"
      class="tableshowproduct"
      :title="tableTitle"
    >
      <tableShow :sourceTable="sourceTable" :productProps="productProps" @dowLoad="dowLoad"></tableShow>
    </el-dialog>
  </div>
</template>
<script>
import { barOptionConfig } from "@/libs/echartOption/barOption.js";
import { pieOptionConfig } from "@/libs/echartOption/pieOption.js";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { bubbleSort } from "@/libs/commonMethod";

import {
  getRecentOneMonth,
  getRecentSevenDay,
  getSinceThreeMonth
} from "@/libs/date";
import tableShow from "./tableShow";
import html2canvas from "html2canvas";
const moment = require("moment");

export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick:(picker) => {
            this.getRecentDate(picker,1);
          }
        },{
          text: '近7日',
          onClick:(picker) => {
            this.getRecentDate(picker,7);
          }
        }, {
          text: '近15日',
          onClick:(picker) => {
            this.getRecentDate(picker,15);
          }
        }, {
          text: '近30日',
          onClick:(picker) => {
            this.getRecentDate(picker,30);
          }
        }, {
          text: '近90日',
          onClick:(picker) => {
            this.getRecentDate(picker,90);
          }
        }, {
          text: '近365日',
          onClick:(picker) => {
            this.getRecentDate(picker,365);
          }
        }]
      },
      historyDate: [
        { name: "今日" },
        { name: "近7天" },
        { name: "近30天" },
        { name: "近90天" }
      ],
      historyIndex: 2,
      countShow: [
        { name: "处理链接总量", link: "/analyzeMain", number: 0 ,totle: 0},
        { name: "处理授权链接量", number: 0 ,totle: 0},
        { name: "处理非授权链接量", number: 0 ,totle: 0},
        { name: "异常举报链接量", number: 0 ,totle: 0}
      ],
      deductionList: [],
      timeDate: [
        getRecentOneMonth()[0].slice(0, 10),
        getRecentOneMonth()[1].slice(0, 10)
      ],
      listData: {
        groupByShopname: [],
        groupCountByProduct: [],
        groupCountByCreateusername : [],
      },
      sourceTable: [],
      productProps: [],
      shopLoading: false,
      dialogVisible: false,
      tableTitle: "",
      type: ""
    };
  },
  components: { tableShow },
  computed: {
    lowPriceLinkProduct: () => {
      return [
        {
          legend: ["产品1", "产品2", "产品3"],
          toolbox: true,
          type: "default",
          seriesData: [
            {
              name: "产品1",
              value: 20
            },
            {
              name: "产品2",
              value: 40
            },
            {
              name: "产品3",
              value: 10
            }
          ]
        }
      ];
    },
    lowPriceLinkProduct2: () => {
      let legend = [
        "hi不度二不度二多或或或或你好好水水水水是事实上蓄势待发",
        "违规违规违规违规违规违规违规违规"
      ];

      let seriesData = {
        legend,
        axisTick: { show: true },
        xData: [
          "淘宝网",
          "天猫商城",
          "京东商城",
          "苏宁易购",
          "拼多多",
          "当当",
          "sss",
          "sxx",
          "555",
          "sxxx",
          "xxx",
          "上看看萨克斯开始开始开始看"
        ],
        toolbox: true,
        type: "bar",
        data: [
          {
            name: "hi不度二不度二多或或或或你好好水水水水是事实上蓄势待发",
            data: [33, 12, 33, 11, 9, 33, 11, 9, 33, 11, 9]
          },
          {
            name: "违规违规违规违规违规违规违规违规",
            data: [33, 12, 33, 11, 9, 33, 11, 9, 33, 11, 9]
          }
        ],
        grid: {
          right: "8%",
          left: 0,
          bottom: "20%",
          top: "5%",
          containLabel: true
        },
        commondataZoom: true,
        madeLegend: {
          type: "scroll",
          data: legend,
          y: "bottom",
          x: "center",
          bottom: 0,
          itemWidth: 8,
          itemHeight: 8
        }
      };
      return seriesData;
    }
  },
  mounted() {
    let _this = this;
    window.addEventListener("resize", function() {
      _this.platformCharts2.resize();
      _this.chartLine.resize();
      _this.outCharts.resize();
      _this.platformCharts4.resize();
    });
    this.getReportAnalyse();
  },
  methods: {
    dowLoad() {
      let url;
      let name;
      let type = this.type;
      if (type == 1) {
        name = "违规举报链接来源及数量分析";
        url = "/hcm/hcmReport/downloadSourceTable";
      } else if (type == 2) {
        name = "违规举报链接所属平台占比";
        url = "/hcm/hcmReport/downloadReportByPlatformTable";
      } else if (type == 3) {
        name = "授权店铺违规情况排名";
        url = "/hcm/hcmReport/downloadReportAnalyse";
      } else if (type == 4) {
        name = "授权店铺链接违规处理结果分析";
        url = "/hcm/hcmReport/downloadReportByResultTable";
      } else if (type == 5) {
        name = "非授权链接处理方式分析";
        url = "/hcm/hcmReport/downloadReportByNoAuthTable";
      } else if (type == 6) {
        name = "违规产品排名";
        url = "/hcm/hcmReport/downloadReportAnalyse";
      } else if (type == 7) {
        name = "举报人举报次数排行";
        url = "/hcm/hcmReport/downloadReportAnalyse";
      }
      let data = {
        starttime: this.timeDate[0],
        endtime: this.timeDate[1]
      };
      if (type == 3) {
        data.type = 'shop'
      } else if (type == 6) {
        data.type = 'product'
      } else if (type == 7) {
        data.type = 'user'
      }
      fetch({
        url,
        method: "get",
        params: data,
        noFormat: true,
        responseType: "blob"
      }).then(res => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `${name}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },
    //点击生成图片
    generatorImage(id, name) {
      setTimeout(() => {
        let targetDom = document.getElementById(id);
        window.pageYOffset = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        html2canvas(targetDom, {
          allowTaint: false,
          useCORS: true,
          height: targetDom.offsetHeight,
          width: targetDom.offsetWidth,
          windowWidth: document.body.scrollWidth,
          windowHeight: document.body.scrollHeight,
          x: 0,
          y: 0, // 用网页滚动的高度定位y轴顶点
          dpi: window.devicePixelRatio * 2,
          scale: 2,
          useCORS: true,
          foreignObjectRendering: true
        }).then(function(canvas) {
          let link = document.createElement("a");
          link.href = canvas.toDataURL(); //下载链接
          link.setAttribute("download", name);
          link.style.display = "none"; //a标签隐藏
          document.body.appendChild(link);
          link.click();
        });
      }, 500);
    },
    // 准备下载
    readyDownload(type) {
      this.type = type
      this.dowLoad()
    },
    tableSHow(type) {
      this.type = type;
      this.dialogVisible = true;
      let data = {
        starttime: this.timeDate[0],
        endtime: this.timeDate[1]
      };
      if (type === 1) {
        this.getSourceTable(data);
      } else if (type === 2) {
        //违规举报链接所属平台占
        this.getReportByPlatformTable(data);
      } else if (type == 3) {
        this.tableTitle = "授权店铺违规情况排名";
        this.sourceTable = this.listData.groupByShopname;
        this.productProps = [
          { prop: "platform", label: "平台" },
          { prop: "shopname", label: "店铺名称" },
          { prop: "count", label: "违规总次数" },
          { prop: "passNum", label: "整改合格" },
          { prop: "appealNum", label: "申诉合理" },
        ];
      } else if (type == 4) {
        this.getReportByResultTable(data);
      } else if (type == 5) {
        this.getReportByNoAuthTable(data);
      } else if (type == 6) {
        this.tableTitle = "违规产品排名";
        this.sourceTable = this.listData.groupCountByProduct;
        this.productProps = [
          { prop: "productname", label: "产品" },
          { prop: "count", label: "链接数" },
        ];
      } else if (type == 7) {
        this.tableTitle = "举报人举报次数排行";
        this.sourceTable = this.listData.groupCountByCreateusername;
        this.productProps = [
          { prop: "createusername", label: "举报人" },
          { prop: "count", label: "链接数" },
        ];
      }
    },
    getSourceTable(data) {
      this.tableTitle = "违规举报链接来源及数量分析";
      fetchGet("hcm/hcmReport/getSourceTable", data).then(res => {
        if (res.status === "10000") {
          this.sourceTable = res.data;
          this.productProps = [
            { prop: "date", label: "日期", width: 100 },
            { prop: "allcount", label: "全部" },
            { prop: "shopcount", label: "店铺经销商举报" },
            { prop: "hcmcount", label: "品牌方人员举报" },
            { prop: "kefucount", label: "求美客服举报" }
          ];
        }
      });
    },
    getReportByPlatformTable(data) {
      this.tableTitle = "违规举报链接所属平台占比";
      fetchGet("hcm/hcmReport/getReportByPlatformTable", data).then(res => {
        if (res.status === "10000") {
          this.sourceTable = res.data;
          this.productProps = [
            { prop: "platformname", label: "平台" },
            { prop: "proportion", label: "占比" },
            { prop: "count", label: "链接数量" }
          ];
        }
      });
    },
    getReportByResultTable(data) {
      this.tableTitle = "授权店铺链接违规处理结果分析";
      fetchGet("hcm/hcmReport/getReportByResultTable", data).then(res => {
        if (res.status === "10000") {
          this.sourceTable = res.data;
          this.productProps = [
            { prop: "result", label: "处理结果" },
            { prop: "proportion", label: "占比" },
            { prop: "count", label: "链接数量" }
          ];
        }
      });
    },
    getReportByNoAuthTable(data) {
      this.tableTitle = "非授权链接处理方式分析";
      fetchGet("hcm/hcmReport/getReportByNoAuthTable", data).then(res => {
        if (res.status === "10000") {
          this.sourceTable = res.data;
          this.productProps = [
            { prop: "result", label: "平台" },
            { prop: "proportion", label: "占比" },
            { prop: "count", label: "链接量" }
          ];
        }
      });
    },
    getSeriesData(series) {
      let legend = ["店铺经销商举报", "品牌方人员举报", "求美客服举报"];
      // 2026.01.19严旭让把违规链接来源及数量分析  从老到新重新排序
      series.series.map(item => {
        // item.data = item.data.reverse();
        item.data = item.data;
      });
      // let xData=series.dateList.reverse()
      let xData=series.dateList
      let params={
        legend,
        axisTick: { show: true },
        xData,
        toolbox: true,
        type: "bar",
        data: series.series,
        grid: {
          right: "8%",
          left: 0,
          bottom: "20%",
          top: "5%",
          containLabel: true
        },
        madeLegend: {
          type: "scroll",
          data: legend,
          y: "bottom",
          x: "center",
          bottom: 0,
          itemWidth: 8,
          itemHeight: 8
        }
      }
      this.historyIndex==2?params.commondataZoom=true:delete params.commondataZoom //横向滚动条
      xData.length>=29?params.commondataZoom=true:delete params.commondataZoom //横向滚动条
      return params;
    },
    getRecentDate(picker,n){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if(picker){
        picker.$emit('pick', [start, end]);
      }

      this.timeDate[0] = this.$options.filters['fullTime'] (start).substring(0,10);
      this.timeDate[1] = this.$options.filters['fullTime'] (end).substring(0,10);
      this.getReportAnalyse()
    },
    getReportAnalyse() {
      this.shopLoading = true
      let data = {
        starttime: this.timeDate[0],
        endtime: this.timeDate[1]
      };
      fetchGet("/hcm/hcmReport/getReportAnalyse", data).then(res => {
        if (res.status === "10000") {
          this.shopLoading = false
          this.listData = res.data;
          this.listData.groupByShopname = bubbleSort(
            this.listData.groupByShopname,
            "count"
          ).reverse();
          this.listData.groupCountByProduct = bubbleSort(
            this.listData.groupCountByProduct,
            "count"
          ).reverse();
          this.listData.groupCountByCreateusername = bubbleSort(
            this.listData.groupCountByCreateusername,
            "count"
          ).reverse();

          let { authList, noAuthList, errorList, authProp, noAuthProp, errorProp} = res.data;
          this.countShow = [
            {
              name: "处理链接总量",
              link: "/analyzeMain",
              number: Number(authList) + Number(noAuthList) + Number(errorList),
              totle: 0
            },
            { name: "处理授权链接量", number: authList ,totle: authProp},
            { name: "处理非授权链接量", number: noAuthList ,totle: noAuthProp},
            { name: "异常举报链接量", number: errorList ,totle: errorProp}
          ];
          this.getCharts(res.data);
          this.groupByPlatform(res.data);
          this.noAuthGroupByResult(res.data.noAuthGroupByResult);
        }
      });
    },
    changeHistory(index) {
      const formatType = "YYYY-MM-DD";
      this.historyIndex = index;
      if (index === 0) {
        //今日
        let newTime = moment().format(formatType);
        this.timeDate = [newTime, newTime];
      } else if (index === 1) {
        //近7日
        this.timeDate = [
          getRecentSevenDay()[0].slice(0, 10),
          getRecentSevenDay()[1].slice(0, 10)
        ];
      } else if (index === 2) {
        //近30日
        this.timeDate = [
          getRecentOneMonth()[0].slice(0, 10),
          getRecentOneMonth()[1].slice(0, 10)
        ];
      } else if (index === 3) {
        //近90日
        this.timeDate = [
          getSinceThreeMonth()[0].slice(0, 10),
          getSinceThreeMonth()[1].slice(0, 10)
        ];
      }
      this.getReportAnalyse();
    },
    getCharts(data) {
      //违规举报链接来源及数量分析
      let _this = this;
      this.$nextTick(() => {
        //违规链接
        _this.outCharts = _this.$echarts.init(
          document.getElementById("outCharts")
        );
        _this.outCharts.resize();
        _this.outCharts.setOption(barOptionConfig(this.getSeriesData(data)),true);
      });
    },
    getPieConfig(data, text) {
      let legend = [];
      let seriesData = [];
      let total = 0;
      for (let key in data) {
        legend.push(key);
        seriesData.push({
          name: key,
          value: data[key]
        });
        total += data[key];
      }

      return [
        {
          legend,
          seriesData,
          toolbox: true,
          graphic: this.getgraphic(total, text),
          grid: {
            right: "2%",
            left: 0,
            bottom: "20%",
            top: "5%",
            containLabel: true
          }
        }
      ];
    },
    getgraphic(total, text) {
      return [
        {
          type: "text",
          left: "27%",
          top: "40%",
          style: {
            text: total,
            fill: "#66666",
            fontSize: 32,
            fontWeight: "bold",
            textAlign: "center"
          }
        },
        {
          type: "text",
          left: "27%",
          top: "55%",
          style: {
            text: text ? text : "总数量",
            fill: "#666666",
            fontSize: 14,
            textAlign: "center"
          }
        }
      ];
    },
    groupByPlatform(data) {
      console.log(data)
      let _this = this;
      this.$nextTick(() => {
        //违规举报链接所属平台占比
        _this.chartLine = _this.$echarts.init(
          document.getElementById("platformCharts")
        );
        let groupByPlatform = {
          ...data.groupByPlatform
        };
        _this.chartLine.setOption(
          pieOptionConfig(this.getPieConfig(groupByPlatform),true)
        );
        //授权店铺链接违规处理结果分析
        _this.platformCharts2 = _this.$echarts.init(
          document.getElementById("platformCharts2")
        );
        _this.platformCharts2.setOption(
          pieOptionConfig(this.getPieConfig(data.groupByResult),true)
        );
      });
    },
    noAuthGroupByResult(data) {
      console.log(data)
      //非授权链接处理方式分析
      let _this = this;
      // data["知识产权投诉"] = 50;
      let learnNum = data["知识产权投诉"] ? Number(data["知识产权投诉"]) : 0;
      let noticeNum = data["通知店铺整改"] ? Number(data["通知店铺整改"]) : 0;
      let total = learnNum + noticeNum;
      let seriesData = [
        {
          name: "知识产权投诉",
          seriesData: [
            {
              name: "知识产权投诉",
              value: learnNum,
              percentage: total ? ((learnNum / total) * 100).toFixed(2) : 0
            }
          ],
          graphic: this.getgraphic(),
          percent: true,
          center: ["50%", "30%"],
          radius: [80, 60]
        },
        {
          name: "通知店铺整改",
          seriesData: [
            {
              name: "通知店铺整改",
              value: noticeNum,
              percentage: total ? ((noticeNum / total) * 100).toFixed(2) : 0
            }
          ],
          center: ["50%", "80%"],
          radius: [80, 60]
        }
      ];
      this.$nextTick(() => {
        _this.platformCharts4 = _this.$echarts.init(
          document.getElementById("platformCharts4")
        );
        _this.platformCharts4.setOption(pieOptionConfig(seriesData),true);
      });
    }
  }
};
</script>
<style lang="scss">
@import "style/fontSize.scss";
@import "style/outReview.scss";
.creditAnalyze {
  .el-card {
    border-radius: 16px;
    box-shadow: none !important;
  }
  .prompt {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin: 8px 0 8px 0;
  }
  .promptFont{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
  }
  .fix_top{
    position: absolute;
    right: 0;
  }
  .right{
    text-align: right;
  }
  .header_none {
    display: none;
  }
  .ranking {
    margin-top: 10px;
    .content {
      border-radius: 6px;
      height: 355px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .content_main {
      height: 100%;
    }
  }
  .drawer-subtitle_common {
    border-left: 5px solid black;
  }
  .tab_relative {
    position: relative;
  }
  .seeInfo {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #108cee;
    cursor: pointer;
  }
  .active {
    color: #108cee;
  }
  .data_right {
    display: inline;
    margin-right: 20px;
    cursor: pointer;
  }
  .no_margin {
    margin: 0;
    height: 20px;
  }
  .card_relative {
    position: relative;
  }
  .table-show-iocn {
    position: absolute;
    right: 20px;
    top: 29px;
    z-index: 99;
  }
}
</style>
